import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Auth
import { AuthProvider } from './screens/Authcontext';
import ProtectedRoute from './screens/ProtectedRoute';

// Pages
import Login from './screens/Login';
import Dashboard from './screens/Dashboard';
import Mudatmarked from './screens/Mudatmarked';
import UserDataPage from './screens/UserDataPage';
import PrintPage from './screens/PrintPage';
import UserProfile from './screens/UserProfile';
import ControlPanel from './screens/ControlPanel';
import Patotsav from './screens/Patotsav';

// Context
import { UserProvider } from './screens/UserContext';

const router = createBrowserRouter([
  // Public
  { path: '/', element: <Login /> },

  // User Profile (USER role)
  {
    path: '/profile',
    element: (
      <ProtectedRoute requiredPermission="profile">
        <UserProfile />
      </ProtectedRoute>
    ),
  },

  // Dashboard (SUPERADMIN, ADMIN, EDITOR)
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute requiredPermission="dashboard">
        <Dashboard />
      </ProtectedRoute>
    ),
  },

  // Mudat / Attendance List (SUPERADMIN, ADMIN only)
  {
    path: '/mudatmarked',
    element: (
      <ProtectedRoute requiredPermission="mudat">
        <Mudatmarked />
      </ProtectedRoute>
    ),
  },

  // User Data / Print (SUPERADMIN, ADMIN, EDITOR)
  {
    path: '/user-data',
    element: (
      <ProtectedRoute requiredPermission="users">
        <UserDataPage />
      </ProtectedRoute>
    ),
  },

  // Print Page
  {
    path: '/print-page',
    element: (
      <ProtectedRoute requiredPermission="users">
        <PrintPage />
      </ProtectedRoute>
    ),
  },

  // Control Panel (SUPERADMIN only)
  {
    path: '/control-panel',
    element: (
      <ProtectedRoute requiredPermission="control-panel">
        <ControlPanel />
      </ProtectedRoute>
    ),
  },

  // Patotsav (SUPERADMIN only)
  {
    path: '/patotsav',
    element: (
      <ProtectedRoute requiredPermission="control-panel">
        <Patotsav />
      </ProtectedRoute>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <UserProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();